/*==============================================================================
  PRODUCT UX — mejoras progresivas de la ficha de producto
  ----------------------------------------------------------------------------
  1. Calcula el ahorro real y lo muestra junto al precio.
  2. Mueve categorías / tags / SKU a un desplegable para quitar ruido visual.

  Notas de implementación:
  - El tema reescribe el bloque de precio al inicializar las variantes, así que
    el badge se reinyecta con un MutationObserver (con límite de intentos).
  - Todo es idempotente: si la sección se vuelve a renderizar desde el editor de
    temas, no se duplican elementos.
==============================================================================*/
(function () {
  'use strict';

  var MAX_INTENTOS = 24;

  function money(n) {
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0,
      }).format(n);
    } catch (e) {
      return '$' + Math.round(n).toLocaleString('es-CO');
    }
  }

  function parsePrice(text) {
    if (!text) return NaN;
    // "$ 800.000" -> 800000  (formato colombiano: punto = miles)
    var clean = String(text).replace(/[^\d.,]/g, '');
    clean = clean.replace(/\./g, '').replace(',', '.');
    return parseFloat(clean);
  }

  /*--- 1. Badge de ahorro -------------------------------------------------*/
  function addSavingBadge(root) {
    var priceBox = root.querySelector('.t4s-product-price');
    if (!priceBox) return false;
    if (priceBox.querySelector('.t4s-pux-saving')) return true;

    var del = priceBox.querySelector('del');
    var ins = priceBox.querySelector('ins');
    if (!del || !ins) return true; // no hay oferta: nada que hacer

    var before = parsePrice(del.textContent);
    var now = parsePrice(ins.textContent);
    if (!before || !now || before <= now) return true;

    var amount = before - now;
    var pct = Math.round((amount / before) * 100);
    if (pct < 1) return true;

    var badge = document.createElement('span');
    badge.className = 't4s-pux-saving';
    badge.textContent = 'Ahorras ' + money(amount) + ' (-' + pct + '%)';
    badge.title = 'Precio anterior ' + money(before);

    priceBox.appendChild(badge);
    return true;
  }

  function watchPrice(root) {
    var priceBox = root.querySelector('.t4s-product-price');
    if (!priceBox || priceBox.getAttribute('data-pux-watch')) return;
    priceBox.setAttribute('data-pux-watch', '1');

    var intentos = 0;
    var mo = new MutationObserver(function () {
      if (intentos++ > MAX_INTENTOS) {
        mo.disconnect();
        return;
      }
      if (!priceBox.querySelector('.t4s-pux-saving')) addSavingBadge(root);
    });

    mo.observe(priceBox, { childList: true, subtree: true, characterData: true });
  }

  /*--- 2. Meta dentro de un desplegable -----------------------------------*/
  function collapseMeta(root) {
    var meta = root.querySelector('.t4s-product_meta');
    if (!meta) return;
    if (root.querySelector('.t4s-pux-meta')) return;

    var hasContent =
      meta.querySelector('.t4s-collections-wrapper a') ||
      meta.querySelector('.t4s-tags-wrapper a') ||
      meta.querySelector('.t4s-vendor-wrapper');
    if (!hasContent) return;

    var details = document.createElement('details');
    details.className = 't4s-pux-meta';

    var summary = document.createElement('summary');
    summary.textContent = 'Detalles del producto';

    var body = document.createElement('div');
    body.className = 't4s-pux-meta__body';

    details.appendChild(summary);
    details.appendChild(body);

    // Insertar el desplegable en el DOM ANTES de mover el meta dentro,
    // si no el navegador lanza "insertBefore: contains the parent".
    meta.parentNode.insertBefore(details, meta);
    body.appendChild(meta);
    root.classList.add('t4s-pux-meta-ready');
  }

  /*--- 3. Miniaturas de la galería ---------------------------------------- */
  /*  El tema construye las miniaturas con src="...&width=1": un píxel estirado,
      que se ve como un cuadro blanco. Normalmente lazysizes lo reemplaza por la
      imagen real, pero en el editor de temas ese paso no siempre ocurre.

      Aquí SOLO se cambia el atributo src de las miniaturas que estén en width=1.
      No se crean ni se borran nodos y no se toca el carrusel: así el tema sigue
      funcionando igual.                                                        */

  function esPlaceholder(url) {
    if (!url) return true;
    if (url.indexOf('data:') === 0) return true;
    return /[?&]width=1(&|$)/.test(url);
  }

  function urlRealDeSlide(slide) {
    if (!slide) return null;
    var img = slide.querySelector('img');
    if (!img) return null;

    var master = img.getAttribute('data-master');
    if (master) return master;

    var cur = img.currentSrc;
    if (cur && cur.indexOf('http') === 0 && !esPlaceholder(cur)) return cur;

    var set = img.getAttribute('data-srcset') || img.getAttribute('srcset');
    if (set) {
      var partes = set.split(',');
      var ultima = partes[partes.length - 1].trim().split(' ')[0];
      if (ultima && ultima.indexOf('http') === 0) return ultima;
    }
    return null;
  }

  // Rellena con un <img> las miniaturas que el tema dejó vacías.
  // Solo se ejecuta si el carrusel del tema NO se inicializó (caso del editor con
  // "Thumbnails left" / right / bottom). No borra ni mueve nada.
  function rellenarMiniaturasVacias(slides) {
    var vacias = document.querySelectorAll(
      '.t4s-pux .t4s-col-thumb .t4s-product__thumb'
    );
    if (!vacias.length) return 0;

    var rellenadas = 0;

    Array.prototype.forEach.call(vacias, function (thumb, i) {
      if (thumb.querySelector('img')) return; // ya tiene imagen
      var url = urlRealDeSlide(slides[i] || slides[0]);
      if (!url) return;

      var im = document.createElement('img');
      im.setAttribute('src', url);
      im.setAttribute('alt', '');
      im.setAttribute('loading', 'eager');
      im.className = 't4s-pux-thumb-img t4s-pux-thumb-ready lazyloadt4sed';
      thumb.appendChild(im);
      rellenadas++;
    });

    return rellenadas;
  }

  function corregirMiniaturas() {
    var slides = document.querySelectorAll('.t4s-pux [data-main-slide]');
    if (!slides.length) return false;

    // 1) Miniaturas que el tema no llegó a construir: se rellenan
    var rellenadas = rellenarMiniaturasVacias(slides);

    var miniaturas = document.querySelectorAll(
      '.t4s-pux .t4s-carousel__nav img, .t4s-pux .t4s-col-thumb img'
    );
    if (!miniaturas.length) return rellenadas > 0;

    var corregidas = rellenadas;

    Array.prototype.forEach.call(miniaturas, function (img, i) {
      var src = img.getAttribute('src') || '';

      // 1) Si el tema la dejó en 1 píxel, se cambia por la imagen real
      if (esPlaceholder(src)) {
        var url = urlRealDeSlide(slides[i] || slides[0]);
        if (url) {
          img.setAttribute('src', url);
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-bgset');
          src = url;
          corregidas++;
        }
      }

      // 2) Clave: estas imágenes nacen con opacity:0 y solo se ven cuando
      //    lazysizes les añade .lazyloadt4sed. Si eso no ocurrió, se marca
      //    aquí para que el CSS las muestre.
      if (src && !esPlaceholder(src)) {
        img.classList.add('t4s-pux-thumb-ready');
        if (!img.classList.contains('lazyloadt4sed')) {
          img.classList.add('lazyloadt4sed');
          corregidas++;
        }
      }
    });

    return corregidas > 0;
  }

  // Diagnóstico: window.t4sPuxDebug()
  function debug() {
    var nav = document.querySelector('.t4s-pux .t4s-carousel__nav');
    var imgs = document.querySelectorAll('.t4s-pux .t4s-col-thumb img');
    return {
      navEncontrado: !!nav,
      items: nav ? nav.querySelectorAll('.t4s-carousel__nav-item').length : 0,
      slides: document.querySelectorAll('.t4s-pux [data-main-slide]').length,
      miniaturas: imgs.length,
      srcs: Array.prototype.slice.call(imgs, 0, 5).map(function (im) {
        return (im.getAttribute('src') || '').slice(-38);
      }),
    };
  }

  /*--- 4. Clic en miniaturas y zoom ---------------------------------------- */
  /*  En el editor de temas el carrusel de la galería no siempre se inicializa:
      las miniaturas se ven (las rellena este script) pero al pulsarlas no pasa
      nada, y el botón de zoom tampoco responde.
      Aquí se cubren los dos casos SOLO cuando el tema no está activo.         */

  function hayCarrusel() {
    var media = document.querySelector('.t4s-pux [data-main-media]');
    return !!(media && media.flickityt4s);
  }

  function slidesGaleria() {
    return document.querySelectorAll('.t4s-pux [data-main-slide]');
  }

  function indiceActual() {
    var slides = slidesGaleria();
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-selected')) return i;
    }
    return 0;
  }

  function irASlide(i) {
    var media = document.querySelector('.t4s-pux [data-main-media]');
    var api = media && media.flickityt4s;

    if (api && typeof api.select === 'function') {
      api.select(i);
      return;
    }

    // Sin carrusel: se muestran/ocultan las slides a mano
    var slides = slidesGaleria();
    Array.prototype.forEach.call(slides, function (s, j) {
      s.style.display = (j === i) ? '' : 'none';
      s.classList.toggle('is-selected', j === i);
    });
  }

  function activarClicMiniaturas() {
    // Si el carrusel del tema está activo, él ya maneja los clics
    if (hayCarrusel()) return;

    var thumbs = document.querySelectorAll(
      '.t4s-pux .t4s-col-thumb .t4s-product__thumb-item, .t4s-pux .t4s-col-thumb .t4s-carousel__nav-item'
    );

    Array.prototype.forEach.call(thumbs, function (t, i) {
      if (t.getAttribute('data-pux-click')) return;
      t.setAttribute('data-pux-click', '1');
      t.style.cursor = 'pointer';
      t.addEventListener('click', function () {
        irASlide(i);
      });
    });
  }

  function montarZoom() {
    var overlay = document.querySelector('.t4s-pux-zoom');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 't4s-pux-zoom';
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="t4s-pux-zoom__close" aria-label="Cerrar">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>' +
      '</button>' +
      '<button type="button" class="t4s-pux-zoom__prev" aria-label="Anterior">' +
      '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<img alt="">' +
      '<button type="button" class="t4s-pux-zoom__next" aria-label="Siguiente">' +
      '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) cerrarZoom();
    });
    overlay.querySelector('.t4s-pux-zoom__close').addEventListener('click', cerrarZoom);
    overlay.querySelector('.t4s-pux-zoom__prev').addEventListener('click', function (ev) {
      ev.stopPropagation();
      moverZoom(-1);
    });
    overlay.querySelector('.t4s-pux-zoom__next').addEventListener('click', function (ev) {
      ev.stopPropagation();
      moverZoom(1);
    });

    document.addEventListener('keydown', function (ev) {
      if (overlay.hidden) return;
      if (ev.key === 'Escape') cerrarZoom();
      if (ev.key === 'ArrowLeft') moverZoom(-1);
      if (ev.key === 'ArrowRight') moverZoom(1);
    });

    return overlay;
  }

  function pintarZoom(indice) {
    var overlay = montarZoom();
    var slides = slidesGaleria();
    var url = urlRealDeSlide(slides[indice] || slides[0]);
    if (!url) return;
    overlay.querySelector('img').setAttribute('src', url);
    overlay.setAttribute('data-index', String(indice));
  }

  function abrirZoom(indice) {
    var overlay = montarZoom();
    pintarZoom(indice);
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function cerrarZoom() {
    var overlay = document.querySelector('.t4s-pux-zoom');
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function moverZoom(delta) {
    var overlay = document.querySelector('.t4s-pux-zoom');
    if (!overlay) return;
    var total = slidesGaleria().length;
    if (!total) return;
    var actual = parseInt(overlay.getAttribute('data-index') || '0', 10);
    var siguiente = (actual + delta + total) % total;
    pintarZoom(siguiente);
    irASlide(siguiente);
  }

  // Traducción de respaldo: si el locale es.json no está aplicado, el botón
  // de zoom sigue saliendo en inglés ("Click to enlarge").
  function traducirZoom() {
    var span = document.querySelector('.t4s-pux [data-pr-trigger-pswp] .t4s-pr__text-btn');
    if (span && /click to enlarge/i.test(span.textContent)) {
      span.textContent = 'Clic para ampliar';
    }
  }

  function activarZoom() {
    traducirZoom();

    var btn = document.querySelector('.t4s-pux [data-pr-trigger-pswp]');
    if (!btn || btn.getAttribute('data-pux-zoom')) return;

    // Si el tema ya tiene su visor (PhotoSwipe + carrusel), no se interviene
    if (hayCarrusel() && typeof window.PhotoSwipe === 'function') return;

    btn.setAttribute('data-pux-zoom', '1');
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      abrirZoom(indiceActual());
    }, true);
  }

  /*--- 5. Respaldo de cantidad -------------------------------------------- */
  /*  Si el JS del tema no arranca (pasa en el editor de temas y con algún
      bloqueador), los botones + y − no responden. Aquí se comprueba: si al
      pulsar el valor no cambió, se cambia desde aquí.

      No interfiere cuando el tema funciona: en ese caso el valor ya cambió y
      este código no hace nada.                                                */

  function activarCantidad() {
    var form = document.querySelector('.t4s-pux form[action*="/cart/add"]');
    if (!form || form.getAttribute('data-pux-qty')) return;
    form.setAttribute('data-pux-qty', '1');

    var input = form.querySelector('input[name="quantity"]');
    if (!input) return;

    function cambia(delta) {
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '9999', 10);
      var actual = parseInt(input.value || '1', 10);
      if (isNaN(actual)) actual = 1;
      var nuevo = Math.min(max, Math.max(min, actual + delta));
      if (nuevo === actual) return;
      input.value = nuevo;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var mas = form.querySelector('[data-increase-qty]');
    var menos = form.querySelector('[data-decrease-qty]');

    if (mas) {
      mas.addEventListener('click', function () {
        var antes = input.value;
        setTimeout(function () {
          if (input.value === antes) cambia(1);
        }, 0);
      });
    }

    if (menos) {
      menos.addEventListener('click', function () {
        var antes = input.value;
        setTimeout(function () {
          if (input.value === antes) cambia(-1);
        }, 0);
      });
    }
  }

  /*--- 6. Respaldo de variantes ------------------------------------------- */
  /*  Si el JS del tema no arranca (editor de temas, bloqueadores), pulsar un
      color no hace nada. Aquí se comprueba: si al pulsar el swatch el tema no
      cambió el título de la variante, se aplica el cambio desde aquí.

      Datos de las variantes: window.ShopifyAnalytics.meta.product.variants
      (id, price, public_title). El estado agotado se lee de la clase
      .is--soldout del propio swatch.

      Cuando el tema funciona, el título ya cambió y este código no actúa.     */

  var atcTextoOriginal = null;

  function aplicarVariante(sw, swatches, form) {
    var nombre = (sw.getAttribute('data-value') || sw.textContent || '').trim();
    var soldout = sw.classList.contains('is--soldout') || sw.classList.contains('is--unavailable');

    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || null;
    var variantes = meta && Array.isArray(meta.variants) ? meta.variants : [];
    var v = null;
    for (var i = 0; i < variantes.length; i++) {
      if ((variantes[i].public_title || '').trim() === nombre) { v = variantes[i]; break; }
    }

    // 1. Marcar el swatch
    Array.prototype.forEach.call(swatches, function (x) { x.classList.remove('is--selected'); });
    sw.classList.add('is--selected');

    // 2. Título "COLOR: X"
    var label = document.querySelector('.t4s-pux .t4s-swatch__current');
    if (label) label.textContent = nombre;

    // 3. URL con la variante
    if (v && v.id && window.history && history.replaceState) {
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
    }

    // 4. Campo oculto id del formulario (lo que envía Shopify al carrito)
    if (v && v.id) {
      var idInput = document.querySelector('.t4s-pux input[name="id"]') || form.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }
      idInput.value = v.id;
    }

    // 5. Estado del botón
    var btn = form.querySelector('.t4s-product-form__submit');
    if (btn) {
      var span = btn.querySelector('.t4s-btn-atc_text');
      if (atcTextoOriginal === null && span) atcTextoOriginal = span.textContent.trim();

      if (soldout) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        if (span) span.textContent = 'Agotado';
      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        if (span && atcTextoOriginal) span.textContent = atcTextoOriginal;
      }
    }
  }

  function activarVariantes() {
    var form = document.querySelector('.t4s-pux form[action*="/cart/add"]');
    if (!form || form.getAttribute('data-pux-var')) return;

    var swatches = document.querySelectorAll('.t4s-pux .t4s-swatch__item');
    if (!swatches.length) return;

    form.setAttribute('data-pux-var', '1');

    Array.prototype.forEach.call(swatches, function (sw) {
      sw.addEventListener('click', function () {
        var label = document.querySelector('.t4s-pux .t4s-swatch__current');
        var antes = label ? label.textContent.trim() : '';
        var objetivo = (sw.textContent || '').trim();

        // Si ya estaba seleccionado, nada que hacer
        if (antes === objetivo) return;

        setTimeout(function () {
          var ahora = label ? label.textContent.trim() : '';
          // El tema no respondió: se aplica aquí
          if (ahora !== objetivo) aplicarVariante(sw, swatches, form);
        }, 0);
      });
    });
  }

  function init() {
    var roots = document.querySelectorAll('.t4s-pux');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      addSavingBadge(root);
      watchPrice(root);
      // collapseMeta(root);  // desactivado: el cliente no quiere el bloque de detalles
    });

    // El tema tarda en construir la galería: se revisa varias veces
    activarCantidad();
    activarVariantes();

    setTimeout(function () { corregirMiniaturas(); activarClicMiniaturas(); activarZoom(); activarCantidad(); activarVariantes(); }, 1000);
    setTimeout(function () { corregirMiniaturas(); activarClicMiniaturas(); activarZoom(); activarCantidad(); activarVariantes(); }, 2500);
    setTimeout(function () { corregirMiniaturas(); activarClicMiniaturas(); activarZoom(); activarCantidad(); activarVariantes(); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas re-renderiza secciones sin recargar la página
  document.addEventListener('shopify:section:load', init);

  window.t4sPuxEnsureThumbs = corregirMiniaturas;

  // Fuerza una variante por nombre (útil para depurar el respaldo)
  window.t4sPuxSetVariant = function (nombre) {
    var form = document.querySelector('.t4s-pux form[action*="/cart/add"]');
    var swatches = document.querySelectorAll('.t4s-pux .t4s-swatch__item');
    if (!form || !swatches.length) return false;
    var sw = null;
    Array.prototype.forEach.call(swatches, function (x) {
      var n = (x.getAttribute('data-value') || x.textContent || '').trim();
      if (n.toLowerCase() === String(nombre).toLowerCase()) sw = x;
    });
    if (!sw) return false;
    aplicarVariante(sw, swatches, form);
    return true;
  };
  window.t4sPuxDebug = debug;

  // Al cambiar de variante el precio cambia: recalcular el ahorro.
  // Solo se recalcula el badge, no se vuelve a inicializar todo (eso acumulaba
  // temporizadores y podía interferir con el formulario del tema).
  document.addEventListener('variant:changed', function () {
    var roots = document.querySelectorAll('.t4s-pux');
    Array.prototype.forEach.call(roots, function (root) {
      var badge = root.querySelector('.t4s-pux-saving');
      if (badge) badge.remove();
      addSavingBadge(root);
    });
  });

  // Expuesto para poder comprobar el respaldo de miniaturas desde la consola
})();
